module.exports = __webpack_public_path__ + "static/media/8_r_shlem_92.81_47.22.2fbdd502.png";